'use strict'

module.exports =
  # does bucket user
  isFeatureEnabled: (key) ->
    settingValue = window.Finch?.getSetting("pull->#{key}")
    return settingValue is 'true' or settingValue is true

  # does not bucket user
  checkSetting: (key) ->
    settingValue = window.Finch?.checkSetting("pull->#{key}")
    return settingValue is 'true' or settingValue is true

  isInTreatment: (experimentName, variantName) ->
    window.Finch?.inTreatment({experimentName, variantName})
